// extracted by mini-css-extract-plugin
export default {"container":"LastMatchesResults_container__sgUxr","win":"LastMatchesResults_win__+sZDK","lose":"LastMatchesResults_lose__LDI11","draw":"LastMatchesResults_draw__6JiKY"};